import { secureApiGet } from '../secureHttp';
import { Process } from '../../../types/process';

export interface ProcessesListResponse {
  data: Process[];
  total: number;
}

export interface ProcessesListQuery extends Record<string, unknown> {
  skip?: number;
  take?: number;
  status?: string;
  patient_id?: string;
  psychologist_id?: string;
}

interface ApiCoreListResponse<T> {
  metadata?: {
    total?: number;
    pages?: number;
    current_page?: number;
    per_page?: number;
    has_next_page?: boolean;
    has_prev_page?: boolean;
  };
  results: T[];
}

interface ApiCoreProcessItem {
  id: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  status?: string | { id?: string; name?: string };
  psychologist?: string | { id?: string; name?: string };
  price?: string | { id?: string };
  type?: string | { id?: string; name?: string };
  reason?: string;
  total_sessions?: number;
  next_session_date?: string;
  last_session_date?: string;
  metadata?: { created_at?: string; updated_at?: string };
}

export async function getProcesses(params?: ProcessesListQuery): Promise<ProcessesListResponse> {
  const resp = await secureApiGet<ApiCoreListResponse<ApiCoreProcessItem>>('/v2/processes', params);
  const items = Array.isArray(resp.results) ? resp.results : [];
  const data: Process[] = items.map((p) => ({
    id: p.id,
    created_at: p.created_at ?? p.metadata?.created_at ?? '',
    updated_at: p.updated_at ?? p.metadata?.updated_at ?? p.created_at ?? '',
    deleted_at: p.deleted_at ?? undefined,
    status: typeof p.status === 'string' ? p.status : (p.status?.name ?? p.status?.id ?? ''),
    psychologist: typeof p.psychologist === 'string' ? p.psychologist : (p.psychologist && 'id' in p.psychologist ? (p.psychologist.id ?? '') : ''),
    price: typeof p.price === 'string' ? p.price : (p.price?.id ?? ''),
    type: typeof p.type === 'string' ? p.type : (p.type?.id ?? ''),
    reason: p.reason,
    total_sessions: p.total_sessions,
    activation_date: undefined,
    last_session_date: p.last_session_date,
    next_session_date: p.next_session_date
  }));
  const total = resp.metadata?.total ?? data.length;
  return { data, total };
}


